import React from 'react';
import { useTranslation } from 'react-i18next';

import logo from '../../assets/footer_logo.webp';

import './Footer.scss';

import { FaInstagram } from 'react-icons/fa';

import { Link } from 'react-router-dom';

import call from '../../assets/footer/calling.webp';
import time from '../../assets/footer/time.webp';
import location from '../../assets/footer/location.webp';

const Footer = () => {
    const { t } = useTranslation();

    const footerContacts = [
        {
            title: t('footer.contacts.phoneEmail.title'),
            phone: '0521 / 7708288',
            email: 'info@zahnarztpraxispankrazlichagin.com',
            icon: call
        },
        {
            title: t('footer.contacts.openingHours.title'),
            info: t('footer.contacts.openingHours.info'),
            icon: time
        },
        {
            title: t('footer.contacts.address.title'),
            info: 'Elverdisser Straße 42, 33729 Bielefeld',
            icon: location
        }
    ];

    return (
        <footer className="pt-100 pb-70">

            <div className="container">

                <div className="row">

                    {/* LEFT */}
                    <div className="col-lg-6 col-md-6">

                        <div className="footer-logo">
                            <img
                                src={logo}
                                alt="Zahnarztpraxis Pankraz & Lichagin"
                            />
                        </div>

                        <p className="footer-description">
                            {t('footer.description')}
                        </p>

                        <div className="social-logo">

                            <p>
                                {t('footer.followUs')}
                            </p>

                            <ul>
                                <li>
                                    <a
                                        href="https://www.instagram.com/zahnarztpraxispankraz_lichagin/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="Instagram"
                                    >
                                        <FaInstagram />
                                    </a>
                                </li>
                            </ul>

                        </div>

                    </div>

                    {/* EMPTY SPACE DESKTOP */}
                    <div className="col-lg-2 footer-space"></div>

                    {/* CONTACT */}
                    <div className="col-lg-4 col-md-6">

                        <div className="footer-contact">

                            <p className="footer-contact-title">
                                {t('footer.contactTitle')}
                            </p>

                            {footerContacts.map((footerContact, index) => (
                                <div
                                    className="contact-list"
                                    key={index}
                                >

                                    <div className="contact-icon">
                                        <img
                                            src={footerContact.icon}
                                            alt=""
                                        />
                                    </div>

                                    <div className="contact-text">

                                        <p>
                                            {footerContact.title}
                                        </p>

                                        {footerContact.phone && (
                                            <a
                                                className="contact-phone"
                                                href={`tel:${footerContact.phone.replace(/\s/g, '')}`}
                                            >
                                                {footerContact.phone}
                                            </a>
                                        )}

                                        {footerContact.email && (
                                            <a
                                                className="contact-email"
                                                href={`mailto:${footerContact.email}`}
                                            >
                                                {footerContact.email}
                                            </a>
                                        )}

                                        {footerContact.info && (
                                            <h5>
                                                {footerContact.info}
                                            </h5>
                                        )}

                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>

                </div>

                {/* COPYRIGHT */}
                <div className="copyright-area">

                    <div className="copy-text">

                        <p>
                            &copy; {new Date().getFullYear()}{' '}
                            Zahnarztpraxis Pankraz & Lichagin.{' '}
                            {t('footer.copyright')}
                        </p>

                    </div>

                    <div className="copy-links">

                        <ul>

                            <li>
                                <Link to="/datenschutz">
                                    {t('footer.links.privacy')}
                                </Link>
                            </li>

                            <li>
                                <Link to="/impressum">
                                    {t('footer.links.imprint')}
                                </Link>
                            </li>

                            <li>
                                <Link to="/cookie-einstellungen">
                                    {t('footer.links.cookies')}
                                </Link>
                            </li>

                        </ul>

                    </div>

                </div>

            </div>

        </footer>
    );
};

export default Footer;